import React from 'react'
import Image from "next/image";
import Head from "next/head";
import styles from "./TNPSC-enrischment-program.module.css";
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import carouselBGimg11 from "../../assets/images/home/Banner/TNPSC_GMAT_Webbanner_23_1_2024 (1).jpg";
import Link from 'next/link';


const TnpscWorkshop = () => {
    return (
        <>

        <Head>
            <meta charset="UTF-8" />
            <link rel="icon" href="./logo.png" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>TNPSC General Enrichment Programme 2024 - Shankar IAS Academy</title>
            <meta name="title" content="TNPSC General Enrichment Programme 2024 - Shankar IAS Academy" />
            <meta name="description" content="" />
            <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-general-enrichment-programme-2024/ " />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="TNPSC General Enrichment Programme 2024 - Shankar IAS Academy" />
            <meta property="og:description" content="" />
            <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-general-enrichment-programme-2024/ " />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

            <Navbar title="upsc" />

            <div className="container">
                <div className="pt-3 pt-md-5">
                    <h1 className={`${styles.pagemaintitle}`}>TNPSC General Enrichment Programme 2024 - Shankar IAS Academy</h1>
                </div>
                <div className='row py-3'>
                    <div className='col'>
                         <Image src={carouselBGimg11} className="img-fluid" width={1447} height={438} alt="Enrichment banner" title="Enrichment" />
                    </div>
                </div>
            </div>


            <div className="container">
                <div className='py-2' style={{backgroundColor: "#001e62"}}>
                <h1 className={`${styles.tabletitle}`}>TNPSC-GMAT Enrichment Programme Group II & IV 2024</h1>
                <h1 className={`${styles.tabletitle}`}>(General Mental Ability & General Tamil)</h1>
                </div>
                <div className={`${styles.tablescroll} prelimstable`}>
                    <table className="table">
                        <thead className={`${styles.table}`} >
                            <tr>
                                <td className={`${styles.tableheading}`}>Center<br /></td>
                                <td className={`${styles.tableheading}`}>Batch<br /></td>
                                <td className={`${styles.tableheading}`}>Starts On<br /></td>
                                <td className={`${styles.tableheading}`}>Fee<br /></td>
                                <td className={`${styles.tableheading}`}>Payment<br /></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="pt-2">
                                <td className={`${styles.tablepara}`}>Chennai-Anna Nagar<br /></td>
                                <td className={`${styles.tablepara}`}>Regular (Offline/Online)<br /></td>
                                <td className={`${styles.tablepara}`}>15th February 2024<br /></td>
                                <td className={`${styles.tablepara}`}>₹10000<br /></td>
                                <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                            </tr>
                            <tr className="pt-2">
                                <td className={`${styles.tablepara}`}>Coimbatore<br /></td>
                                <td className={`${styles.tablepara}`}>Regular (Offline/Online)<br /></td>
                                <td className={`${styles.tablepara}`}>05 February 2024<br /></td>
                                <td className={`${styles.tablepara}`}>₹10000<br /></td>
                                <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <Footer />
        </>
    )
}

export default TnpscWorkshop;